<template lang="pug">
  .boxMenu(@click="updateBox" :class="{ select : isSelect }")
    .title
      span {{ title }}
</template>

<script>
export default {
  name: 'BoxMenu',
  props: {
    value: {
      type: Number
    },
    title: {
      type: String
    },
    subtype: {
      type: Number
    },
    to: {
      type: String
    }
  },
  computed: {
    isSelect () {
      return this.to === this.$route.path
    }
  },
  methods: {
    updateBox () {
      this.$router.push(this.to)
    }
  }
}
</script>
<style lang="stylus" scoped>
.select
  background rgb(237, 28, 36)
  border-radius 20px !important
  -webkit-box-shadow 1px 5px 10px -6px rgba(0,0,0,0.31)
  -moz-box-shadow 1px 5px 10px -6px rgba(0,0,0,0.31)
  box-shadow 1px 5px 10px -6px rgba(0,0,0,0.31)
  color white
.boxMenu
  display inline-block
  width 100%
  height 40px
  padding 10px 20px
  margin-top 15px
  cursor pointer
  .title
    font-weight bold
    display inline-block
    font-size 15px
</style>
